import Layout from "@/layout/index.vue";
import type { RouteRecordRaw } from "vue-router";
import { agreementsRouter } from "./model/agreements";
import { parentsRouter } from "./model/parents";
import { teacherRouter } from "./model/teacher";
import { studentRouter } from "./model/student";
import { otherRouter } from "./model/other";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "root",
    component: Layout,
    redirect: { name: "Demo" },
    children: [
      // 学生端路由
      ...studentRouter,
      // 老师端路由
      ...teacherRouter,
      // 家长端路由
      ...parentsRouter,
      // 协议相关路由
      ...agreementsRouter,
      // 其他路由
      ...otherRouter,
      // 首页路由
      {
        path: "",
        name: "index",
        component: () => import("@/views/common/index/index.vue"),
        meta: {
          title: "用户三端h5"
        }
      }
    ]
  },
  // 404 兜底路由，必须放在最后，匹配所有未定义路径
  {
    path: "/:pathMatch(.*)*",
    name: "404",
    component: () => import("@/views/common/404/404.vue"),
    meta: {
      title: "页面不存在"
    }
  }
];

export default routes;
